const workingData =[
    {
        id:'1',
        title:'Red Onion',
        description:'Red Onion is a Full-Stack E-commerce website Where client can login or signUp with there email and google which is build with the help of firebase authentication.Here client can buy, review or cancel their order.Here Also have a admin who can add, delete or update products',
        category:'Frontend & backend',
        equipment: ['React js','Javascript','HTML','CSS','Bootstrap','Firebase Auth','Node js', 'Express js','MongoDb'],
        img: 'https://i.postimg.cc/5y6V1pSn/red-onion.png',
        clientCode: 'https://github.com/or-obaidullah/red-onion',
        serverCode:'',
        live:'https://red-onion-d4d41.web.app/'      
    },
    {
        id:'2',
        title:'Doctor Portal',
        description:'Doctor Portal is a Full-Stack doctor finder website Where patients can login or signUp with there email and google which is build with the help of firebase authentication.Here patient can take appointment and will see dashboard where update their profile.Here Also have a admin who can add, delete or update doctors or patients documents',
        category:'Frontend & backend',
        equipment: ['React js','Javascript','HTML','CSS','Bootstrap','Firebase Auth','Node js', 'Express js','MongoDb'],
        img: 'https://i.postimg.cc/YqN3MFdw/doctors-portal.png',
        clientCode: 'https://github.com/or-obaidullah/doctors-portal-client',
        serverCode:'https://github.com/or-obaidullah/doctors-portal-server',
        live:'https://doctor-portal-d0e06.web.app/'
    },
    {
        id:'3',
        title:'Ema John Simple',
        description:'Ema John Simple is a Full-Stack E-commerce website Where client can login or signUp with there email and google which is build with the help of firebase authentication.Here client can buy, review or cancel their order.Here Also have a admin who can add, delete or update products',
        category:'Frontend & backend',
        equipment: ['React js','Javascript','HTML','CSS','Firebase Auth','Node js', 'Express js','MongoDb'],
        img: 'https://i.postimg.cc/mgCX6bFs/ema-john-simple.png',
        clientCode: 'https://github.com/or-obaidullah/ema-john-simple',
        serverCode:'https://github.com/or-obaidullah/ema-john-simple-server',
        live:'https://ema-john-simple-96831.web.app/'
    },  
    // {
    //     id:'4',
    //     title:'Burj Al Arab',
    //     description:'Burj Al Arab is a Full-Stack room booking website Where customer can login or signUp with there email and google which is build with the help of firebase authentication.Here client can book and will see dashboard where update their profile.Here Also have a admin who can add, delete or update products',
    //     category:'Frontend & backend',
    //     equipment: ['React js','Javascript','HTML','CSS','Bootstrap','Firebase Auth','Node js', 'Express js','MongoDb'],
    //     img: '',
    //     clientCode: 'https://github.com/or-obaidullah/burj-al-arab',
    //     serverCode:'',
    //     live:''
        
    // },
    {
        id:'5',
        title:'My Portfolio',
        description:'A single page web application which is build with React js that is mainly focus in portfolio. There are five main component here. They are home, About, works, blog and contact. For contact, I use a third party api for sending email. ',
        category:'Frontend',
        equipment: ['React js', 'Javascript','HTML','CSS'],
        img: 'https://i.postimg.cc/ydbjqNbw/my-portfolio.png',
        clientCode: 'https://github.com/or-obaidullah/my-portfolio',
        live:'https://obaidur.netlify.app/'
    },
    {
        id:'6',
        title:'Jose Smith',
        description:'Jose Smith is personal porfolio website which is built in bootstrap5. Here I use jQuery plugin for slider',
        category:'Frontend',
        equipment: ['JQuery','Html','CSS','bootstrap'],
        img: 'https://i.postimg.cc/dtdbBM7q/jose-smith.png',
        clientCode: 'https://github.com/or-obaidullah/jose-smith',
        live:'https://or-obaidullah.github.io/jose-smith/'
        

    },
    {
        id:'7',
        title:'Quiz App',
        description:'A front end website using JavaScript to become more interactive.Here anyone can apply for quiz.',
        category:'Frontend',
        equipment: ['Javascript','Html','CSS','bootstrap'],
        img: 'https://i.postimg.cc/pV84MYJD/18-quiz-app.png',
        clientCode: 'https://github.com/or-obaidullah/quiz-app',
        live:'https://or-obaidullah.github.io/quiz-app/'
        

    },
    {
        id:'8',
        title:'Pioneer Bank',
        description:'A front end website using JavaScript to become more interactive.',
        category:'Frontend',
        equipment: ['Javascript','Html','CSS','bootstrap'],
        img: 'https://i.postimg.cc/xjJYJzyC/05-payneer-bank-01.png',
        clientCode: 'https://github.com/or-obaidullah/pioneer-bank',
        live:'https://or-obaidullah.github.io/pioneer-bank/index.html'
        

    },
    {
        id:'10',
        title:'Pin Matcher',
        description:'A front end website using JavaScript to become more interactive.',
        category:'Frontend',
        equipment: ['Javascript','Html','CSS'],
        img: 'https://i.postimg.cc/5yZRLjJQ/16-pin-matcher.png',
        clientCode: 'https://github.com/or-obaidullah/pin-matcher',
        live:'https://or-obaidullah.github.io/pin-matcher/'
        

    },
    {
        id:'11',
        title:'Weather Temperature',
        description:'Weather Temperature is a temperature searching website which is build with javascript and using third-party api.',
        category:'Frontend',
        equipment: ['Javascript','Html','CSS','api'],
        img: 'https://i.postimg.cc/J45NbGRw/17-weather-trmperature.png',
        clientCode: 'https://github.com/or-obaidullah/weather-temperature',
        live:'https://or-obaidullah.github.io/weather-temperature/'
    },
    {
        id:'12',
        title:'Panda Commerce',
        description:'Panda Commerce is a front end e-commerce website which is build with bootstrap and it is a static website.',
        category:'Frontend',
        equipment: ['Bootstrap','HTML','CSS'],
        img: 'https://i.postimg.cc/fbGDWWty/03-panda-commerce.png',
        clientCode: 'https://github.com/or-obaidullah/panda-commerce',
        live:'https://or-obaidullah.github.io/panda-commerce/'    
    },
    {
        id:'12',
        title:'E-school Project',
        description:'E-school Project is a front end website for a school which is build with bootstrap and it is a static website',
        category:'Frontend',
        equipment: ['Bootstrap','HTML','CSS'],
        img: 'https://i.postimg.cc/ThMDrv43/13-e-school-project.png',
        clientCode: 'https://github.com/or-obaidullah/e-school-project',
        live:'https://or-obaidullah.github.io/e-school-project/'
    },
    {
        id:'13',
        title:'Hot Gadgets',
        description:'Hot Gadgets is a front end e-commerce website which is build with bootstrap and it is a static website.',
        category:'Frontend',
        equipment: ['Bootstrap','HTML','CSS'],
        img: 'https://i.postimg.cc/9fnzdj4H/04-hot-gadgets.png',
        clientCode: 'https://github.com/or-obaidullah/hot-gadgets',
        live:'https://or-obaidullah.github.io/hot-gadgets/'
    },
    {
        id:'14',
        title:'Shopping Cart',
        description:'Shopping is a simple cart which is interacted by Javascript.',
        category:'Frontend',
        equipment: ['Javascript','Html','CSS'],
        img: 'https://i.postimg.cc/1RHjWY3j/06-shopping-cart.png',
        clientCode: 'https://github.com/or-obaidullah/shopping-cart ',
        live:'https://or-obaidullah.github.io/shopping-cart/'
    },
    {
        id:'15',
        title:'Startup Landing Template',
        description:'A landing website which build with bootstrap.It has some section. When Menu is click then it go to reasonable section.',
        category:'Frontend',
        equipment: ['Bootstrap','HTML','CSS'],
        img: 'https://i.postimg.cc/90JFxtDq/11-startup-landing-page.png',
        clientCode: 'https://github.com/or-obaidullah/startup-landing-template ',
        live:'https://or-obaidullah.github.io/startup-landing-template/'       
    },
    {
        id:'16',
        title:'calculator',
        description:"A simple Calculator using Javascript. Here's have addition, subtract, division and multiplication option",
        category:'Frontend',
        equipment: ['Javascript','Html','CSS'],
        img: 'https://i.postimg.cc/0yh0N7Vv/14-simple-calculator-with-js.png',
        clientCode: 'https://github.com/or-obaidullah/calculator-simple-way-with-js',
        live:'https://or-obaidullah.github.io/calculator-simple-way-with-js/'       
    },
    {
        id:'17',
        title:'Digital Clock',
        description:'Digital Clock is front end website where I have show two clock which is interactive with Javascript',
        category:'Frontend',
        equipment: ['Javascript','Html','CSS'],
        img: 'https://i.postimg.cc/K8S6g3qP/15-digital-clock.png',
        clientCode: 'https://github.com/or-obaidullah/digital-clock',
        live:'https://or-obaidullah.github.io/digital-clock/'  
    },
    {
        id:'18',
        title:'Cuda Simple Portfolio',
        description:'Cuda Simple Portfolio is a frontend website which is focus on portfolio. Mainly It is a landing page with section wise.I use here Mixitup and Progress bar with using jquery plugin',
        category:'Frontend',
        equipment: ['HTML','CSS','Bootstrap','jQuery'],
        img: 'https://i.postimg.cc/g2sgkxfk/10-cuda-simple-portfolio.png',
        clientCode: 'https://github.com/or-obaidullah/cuda-simple-portfolio',
        live:'https://or-obaidullah.github.io/cuda-simple-portfolio/'
    },
    {
        id:'19',
        title:'Looklike Bootstrap',
        description:'Looklike Bootstrap is a frontend website which build with bootstrap4.Mainly It is a landing page with section wise.',
        category:'Frontend',
        equipment: ['HTML','CSS','Bootstrap'],
        img: 'https://i.postimg.cc/gk9SMFVd/08-looklike-bootstarp.png',
        clientCode: 'https://github.com/or-obaidullah/looklike-bootstrap',
        live:'https://or-obaidullah.github.io/looklike-bootstrap/'     
    },
    {
        id:'20',
        title:'Pro-Amp-Electric',
        description:"Pro-Amp-Electric is a static website which is mainly focus on Electric supply company. It's information can not be change without knowledge of code",
        category:'Frontend',
        equipment: ['HTML','CSS'],
        img: 'https://i.postimg.cc/x1JwXy3T/09-pro-amp-electric.png',
        clientCode: 'https://github.com/or-obaidullah/pro-amp-electric',
        live:'https://or-obaidullah.github.io/pro-amp-electric/'
    },
    {
        id:'21',
        title:'Arlo',
        description:'Arlo is a static web site which is build with wordpress by using arlo theme.I built it with the help of elementor.',
        category:'Frontend',
        equipment: ['Wordpress'],
        img: 'https://i.postimg.cc/43KxN9mz/12-arlo-theme-first.png',
        clientCode: 'https://github.com/or-obaidullah/arlo-theme-first',
        live:'https://or-obaidullah.github.io/arlo-theme-first/'
    },
    {
        id:'22',
        title:'Facebook Login Page',
        description:'Facebook Login Page is build for font page like facebook. It is static website.',
        category:'Frontend',
        equipment: ['HTML','CSS'],
        img: 'https://i.postimg.cc/25C1k6nG/07-Facebook-login-page.png',
        clientCode: 'https://github.com/or-obaidullah/facebook-login-page',
        live:'https://or-obaidullah.github.io/facebook-login-page/'      
    },
    {
        id:'23',
        title:'Web Portfolio',
        description:"Web Portfolio is a static website which is mainly focus on personal information. It's information can not be change without knowledge of code.",
        category:'Frontend',
        equipment: ['HTML','CSS'],
        img: 'https://i.postimg.cc/dtR5d5sC/01-web-portfolio.png',
        clientCode: 'https://github.com/or-obaidullah/web-portfolio',
        live:'https://or-obaidullah.github.io/web-portfolio/'        
    },
    {
        id:'24',
        title:'personal-website',
        description:"Personal website is a static website which is mainly focus on personal information. It's information can not be change without knowledge of code.",
        category:'Frontend',
        equipment: ['HTML','CSS'],
        img: 'https://i.postimg.cc/mg2y9R6x/02-personal-website.png',
        clientCode: 'https://github.com/or-obaidullah/personal-website',
        live:' https://or-obaidullah.github.io/personal-website/'
    }
]
export default workingData;